import { SelectionChangedEvent } from "ag-grid-community";
import { customDispatchEvent, E_Custom_Dispatch_Event, E_Type_Of_Event } from "helpers/Events";
import _ from "lodash";
import { INITIAL_DOCUMENT_ENQUIRY_COL_DEF, transferRowData } from "presentation/constant/DocumentEnquiry/DocumentEnquiryColumnDefinition";
import { useDocumentEnquiryVM } from "presentation/hook/DocumentEnquiry/useDocumentEnquiryVM";
import { useDocumentEnquiryTracked } from "presentation/store/DocumentEnquiry/DocumentEnquiryProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { useCallback, useEffect, useRef, useState } from "react";
import { IconButton, Loader } from "veronica-ui-component/dist/component/core";


export const DocumentEnquiryTablePanel = () => {
    const [docEnquiryState] = useDocumentEnquiryTracked();
    const isShowRightCriteriaPanel = docEnquiryState.isShowRightCriteriaPanel;
    const docEnquiryVM = useDocumentEnquiryVM();
    let gridRef: any = useRef();
    const [showOverlay, setShowOverlay] = useState<boolean>(false);
    const tableDoubleClicked = (data: any) => {

        customDispatchEvent(E_Type_Of_Event.MODAL_EVENT, E_Custom_Dispatch_Event.MODAL_FULL_SCREEN_MODE, { isFullScreen: true, className: 'document-search-modal' });
        docEnquiryVM.openContainerDetail(data.data);
    }

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        docEnquiryVM.updateSelectedRows(selectedRows);
    }, [docEnquiryVM])

    useEffect(() => {
        setShowOverlay(docEnquiryState.isSearchLoading || (!docEnquiryState.isSearchLoading &&
            docEnquiryState.docHdrs && docEnquiryState.docHdrs.length) ? false : true);

        if (gridRef.current?.gridRef.current && !docEnquiryState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [docEnquiryState.isSearchLoading, docEnquiryState.docHdrs]);

    return <div className={`table-ag-gird im-charge-data-search-table-panel ag-theme-alpine`} style={{ position: 'relative' }}>
        <div className={`im-charge-data-search-table-panel-content ag-theme-alpine`}>
            {docEnquiryState.isLoading && <Loader Indicator="Spinner" size="Medium" />}
            <NbisTable
                id='document-enquiry-table'
                columns={INITIAL_DOCUMENT_ENQUIRY_COL_DEF?.slice()}
                // cacheBlockSize={30}
                isNewColumnSetting={true}
                isScrollHighlighted={true}
                showPaginator={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                showUploadIcon={true}
                gridHeight="customHeight"
                customHeight={"calc(100% - 25px)"}
                onRowDoubleClick={(e: any) => tableDoubleClicked(e)}
                selectionMode={true}
                rowSelection={"multiple"}
                isRowHighligted={true}
                suppressRowClickSelection={false}
                handleSelectionChanged={handleSelectionChange}
                rowHeight={28}
                // rowBuffer={20}
                ref={gridRef}
                data={!_.isEmpty(docEnquiryState.docHdrs) ? transferRowData(docEnquiryState.docHdrs ?? []) : null}
                // groupDisplayType={"groupRows"}
                // rowGroupPanelShow={"always"}
                autoMarginLeft={true}
                entrypoint={'documentEnquiry'}
                mustRefresh={true}
                showDefaultOverlayNoRowsTemplate={showOverlay}

                columnSettingIconList={[
                    <>
                        <IconButton fileName={isShowRightCriteriaPanel ? "Icon-angle-left" : "Icon-angle-right"} size="medium" toolTipText={isShowRightCriteriaPanel ? "Close Right Panel" : "Open Right Panel"} toolTipArrow={false} onClick={docEnquiryVM.onHideRightCriteriaPanel} />
                    </>
                ]}
            />
        </div>
    </div>;
}